<template>
  <Badge :badgeTypes="badgeTypes" :backgroundColor="backgroundColor" />
</template>

<script>
import { BADGES } from '@/components/_shared/Badge/Badge.vue'
import Badge from '@/components/_shared/Badge/Badge.vue'
import { BACKGROUND_COLORS } from '@/components/_shared/Badge/Badge.vue'

export default {
  name: 'LabelBadge',
  components: { Badge },
  props: {
    productLabels: {
      type: Array,
      required: true,
    },
    productVariantLabels: {
      type: Array,
      required: true,
    },
    isLastChance: {
      type: Boolean,
      default: false,
    },
    isSoldOut: {
      type: Boolean,
      default: false,
    },
    backgroundColor: {
      type: String,
      default: BACKGROUND_COLORS.grey,
    },
  },

  computed: {
    badgeTypes() {
      return [
        ...this.productLabels,
        ...this.productVariantLabels,
        ...this.lastChanceLabel,
        ...this.soldOutLabel,
      ]
    },

    lastChanceLabel() {
      return this.isLastChance ? [BADGES.lastChance.type] : []
    },

    soldOutLabel() {
      return this.isSoldOut ? [BADGES.soldOut.type] : []
    },
  },
}
</script>

<style lang="scss">
</style>
